module.exports = __webpack_public_path__ + "img/circle-gray.f9b1a8ac.svg";